export default __webpack_public_path__ + "assets/images/3.ee5820.avif";